import { Logger } from '@suntex.core/logging';
import { JsonObject, KnownKeys } from '@suntex.core/types';

const logger = Logger.for(() => DataStorage);

export type StorageData = JsonObject;

type KnownStringKeys<T extends StorageData> = KnownKeys<T> & string;

/**
 * Generic adapter for storing and retrieving typed JSON data via the Web Storage API.
 */
export class DataStorage<T extends StorageData> {
  constructor(private readonly storage: Storage) {}

  get<K extends KnownStringKeys<T>>(key: K): T[K] | undefined {
    const value = this.storage.getItem(key);
    try {
      return value ? (JSON.parse(value) as T[K]) : undefined;
    } catch (e) {
      logger.warn(`Failed to parse storage data for key "${key}".`, {}, e);
      return undefined;
    }
  }

  set<K extends KnownStringKeys<T>>(key: K, value: T[K]): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  remove<K extends KnownStringKeys<T>>(key: K): void {
    this.storage.removeItem(key);
  }
}
